// extracted by mini-css-extract-plugin
export default {"mobileNavigation":"navigation_mobileNavigation__gfsSg","navigation":"navigation_navigation__GTDr8"};